import { createSelector } from 'reselect';

import { Selector } from 'react-redux';
import { KeywordState } from './keywordTypes';
import { RootState } from '../../../core/redux/model/rootStateModel';
import { KeywordGetResponse, KeywordValues } from '../model/keywordModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

const getRoot = (state: RootState) => state.keyword;

export const apiKeywordRequestState = createSelector<[Selector<RootState, KeywordState>], API_REQUEST_STATE>(
  getRoot,
  (root: KeywordState) => root.apiKeywordRequestState,
);

export const apiKeywordRequestError = createSelector<[Selector<RootState, KeywordState>], string | null>(
  getRoot,
  (root: KeywordState) => root.apiKeywordRequestError,
);

export const apiKeywordsRequestState = createSelector<[Selector<RootState, KeywordState>], API_REQUEST_STATE>(
  getRoot,
  (root: KeywordState) => root.apiKeywordsRequestState,
);

export const apiKeywordsRequestError = createSelector<[Selector<RootState, KeywordState>], string | null>(
  getRoot,
  (root: KeywordState) => root.apiKeywordsRequestError,
);

export const keyword = createSelector<[Selector<RootState, KeywordState>], KeywordGetResponse>(
  getRoot,
  (root: KeywordState) => root.keyword,
);

export const keywords = createSelector<[Selector<RootState, KeywordState>], KeywordGetResponse[]>(
  getRoot,
  (root: KeywordState) => root.keywords,
);

export const initialValues = createSelector<[Selector<RootState, KeywordState>], KeywordValues>(
  getRoot,
  (root: KeywordState) => {
    return {
      name: root.keyword.name ?? '',
    };
  },
);
